import React, { useState, useEffect } from "react";
import { Router, Route, Switch, Redirect } from "react-router-dom";
import { Auth0Provider, useAuth0 } from "@auth0/auth0-react";
import history from "./utils/history";
import { getConfig } from "./config";
import Loading from "./components/Loading";
import Profile from "./views/Profile";
import ExternalApi from "./views/ExternalApi";


import initFontAwesome from "./utils/initFontAwesome";



import TaskVantage from "./components/TaskVantage";


import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  Menu,
  MenuButton,
  MenuItem,
  MenuItems,
  TransitionChild,
} from "@headlessui/react";
import {
  Bars3Icon,
  BellIcon,
  HomeIcon,
  UsersIcon,
  XMarkIcon,
} from "@heroicons/react/24/outline";
import { ChevronDownIcon, MagnifyingGlassIcon } from "@heroicons/react/20/solid";



initFontAwesome();

const onRedirectCallback = (appState) => {
  history.push(
    appState && appState.returnTo ? appState.returnTo : window.location.pathname
  );
};

// Define the list of sidebar items, including "Home" as the default
const sidebarItems = [
  { name: "B2B", icon: HomeIcon, current: false },
  { name: "User Profile", icon: UsersIcon, current: false },
  // { name: "Multiple Custom Domains", icon: DocumentDuplicateIcon, current: false },
];

// Utility function to merge class names
function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

// Component for the "Multiple Custom Domains" demo
// const MultipleCustomDomainsDemo = ({ selectedDomainIndex, setSelectedDomainIndex, config }) => {
//   const { loginWithRedirect } = useAuth0();

//   return (
//     <div className="bg-white rounded-lg shadow-lg p-6">
//       <h2 className="text-xl font-semibold text-gray-800 mb-4">Multiple Custom Domains Demo</h2>
//       <p className="text-gray-600 mb-4">
//         Select a domain and click "Log in" to authenticate using Auth0 with the chosen domain.
//       </p>
//       <div className="flex items-center space-x-4 mb-4">
//         <label htmlFor="domain-select" className="text-gray-700 font-medium">
//           Select Domain:
//         </label>
//         <select
//           id="domain-select"
//           onChange={(e) => {
//             const newIndex = Number(e.target.value);
//             setSelectedDomainIndex(newIndex);
//             localStorage.setItem("selectedDomainIndex", newIndex.toString());
//           }}
//           value={selectedDomainIndex}
//           className="flex-1 p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-200 bg-white text-gray-700"
//         >
//           <option value={0}>lab.a0demo.com</option>
//           <option value={1}>custom.authdemolab.com</option>
//           <option value={2}>sub.stanleysdemo.com</option>
//         </select>
//       </div>
//       <p className="text-sm text-gray-600 mb-4">
//         Currently using: <span className="font-medium text-blue-600">{config.domain}</span>
//       </p>
//       <button
//         onClick={() => loginWithRedirect()}
//         className="bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 transition duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500"
//       >
//         Log in
//       </button>
//     </div>
//   );
// };

// Inner component that uses useAuth0 and renders the app layout
const AppContent = ({ selectedDomainIndex, setSelectedDomainIndex, config }) => {
  const { isLoading, error, user, logout } = useAuth0();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  // Initialize selectedItem from localStorage, default to "Home"
  const [selectedItem, setSelectedItem] = useState(() => {
    const savedItem = localStorage.getItem("selectedItem");
    return savedItem !== null ? savedItem : sidebarItems[0].name; // Default to "Home"
  });

  // Persist selectedItem in localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem("selectedItem", selectedItem);
  }, [selectedItem]);

  if (isLoading) {
    return <Loading />;
  }

  if (error) {
    return (
      <div className="container mx-auto px-4 py-12">
        <div className="bg-red-50 border-l-4 border-red-500 p-4 rounded-md">
          <p className="text-red-700">
            Authentication Error: {error.message}. Please try again or contact support.
          </p>
        </div>
      </div>
    );
  }

  const userNavigation = [
    // { name: "Your profile", href: "/profile" },
    {
      name: "Sign out",
      onClick: () =>
        logout({
          logoutParams: { returnTo: window.location.origin },
        }),
    },
  ];

  return (
    <div>
      {/* Mobile Sidebar */}
      <Dialog open={sidebarOpen} onClose={setSidebarOpen} className="relative z-50 lg:hidden">
        <DialogBackdrop
          transition
          className="fixed inset-0 bg-gray-900/80 transition-opacity duration-300 ease-linear data-[closed]:opacity-0"
        />
        <div className="fixed inset-0 flex">
          <DialogPanel
            transition
            className="relative mr-16 flex w-full max-w-xs flex-1 transform transition duration-300 ease-in-out data-[closed]:-translate-x-full"
          >
            <TransitionChild>
              <div className="absolute left-full top-0 flex w-16 justify-center pt-5 duration-300 ease-in-out data-[closed]:opacity-0">
                <button
                  type="button"
                  onClick={() => setSidebarOpen(false)}
                  className="-m-2.5 p-2.5"
                >
                  <span className="sr-only">Close sidebar</span>
                  <XMarkIcon aria-hidden="true" className="size-6 text-white" />
                </button>
              </div>
            </TransitionChild>
            <div className="flex grow flex-col gap-y-5 overflow-y-auto bg-indigo-600 px-6 pb-4">
              <div className="flex h-16 shrink-0 items-center">
                <img
                  alt="Auth0 Demos"
                  src="https://mfc.fit/auth0logonew.svg"
                  className="h-8 w-auto"
                />
              </div>
              <nav className="flex flex-1 flex-col">
                <ul role="list" className="flex flex-1 flex-col gap-y-7">
                  <li>
                    <ul role="list" className="-mx-2 space-y-1">
                      {sidebarItems.map((item) => (
                        <li key={item.name}>
                          <button
                            onClick={() => setSelectedItem(item.name)}
                            className={classNames(
                              selectedItem === item.name
                                ? "bg-indigo-700 text-white"
                                : "text-indigo-200 hover:bg-indigo-700 hover:text-white",
                              "group flex gap-x-3 rounded-md p-2 text-sm/6 font-semibold w-full text-left"
                            )}
                          >
                            <item.icon
                              aria-hidden="true"
                              className={classNames(
                                selectedItem === item.name
                                  ? "text-white"
                                  : "text-indigo-200 group-hover:text-white",
                                "size-6 shrink-0"
                              )}
                            />
                            {item.name}
                          </button>
                        </li>
                      ))}
                    </ul>
                  </li>
                </ul>
              </nav>
            </div>
          </DialogPanel>
        </div>
      </Dialog>

      {/* Desktop Sidebar */}
      <div className="hidden lg:fixed lg:inset-y-0 lg:z-50 lg:flex lg:w-72 lg:flex-col">
        <div className="flex grow flex-col gap-y-5 overflow-y-auto bg-indigo-600 px-6 pb-4">
          <div className="flex h-16 shrink-0 items-center">
            <img
              alt="Auth0 Demos"
              src="https://mfc.fit/auth0logonew.svg"
              className="h-8 w-auto"
            />
          </div>
          <nav className="flex flex-1 flex-col">
            <ul role="list" className="flex flex-1 flex-col gap-y-7">
              <li>
                <ul role="list" className="-mx-2 space-y-1">
                  {sidebarItems.map((item) => (
                    <li key={item.name}>
                      <button
                        onClick={() => setSelectedItem(item.name)}
                        className={classNames(
                          selectedItem === item.name
                            ? "bg-indigo-700 text-white"
                            : "text-indigo-200 hover:bg-indigo-700 hover:text-white",
                          "group flex gap-x-3 rounded-md p-2 text-sm/6 font-semibold w-full text-left"
                        )}
                      >
                        <item.icon
                          aria-hidden="true"
                          className={classNames(
                            selectedItem === item.name
                              ? "text-white"
                              : "text-indigo-200 group-hover:text-white",
                            "size-6 shrink-0"
                          )}
                        />
                        {item.name}
                      </button>
                    </li>
                  ))}
                </ul>
              </li>
            </ul>
          </nav>
        </div>
      </div>

      {/* Main Content Area */}
      <div className="lg:pl-72">

        {/* Main Content */}
        <main className="py-10">
          <div className="px-4 sm:px-6 lg:px-8">
            <Router history={history}>
              <Switch>
                <Route path="/" exact>
                 
                  {/* {selectedItem === "Multiple Custom Domains" && (
                    <MultipleCustomDomainsDemo
                      selectedDomainIndex={selectedDomainIndex}
                      setSelectedDomainIndex={setSelectedDomainIndex}
                      config={config}
                    />
                  )} */}
                 
                  {selectedItem === "B2B" && <TaskVantage /> }
                  {selectedItem === "User Profile" && <Profile config={config} />}
                  <Redirect to="/" />
                </Route>
                <Route path="/profile" component={() => <Profile config={config} />} />
                <Route path="/external-api" component={ExternalApi} />
              </Switch>
            </Router>
          </div>
        </main>
      </div>
    </div>
  );
};

// Outer component that manages domain selection and Auth0Provider
const App = () => {
  const [selectedDomainIndex, setSelectedDomainIndex] = useState(() => {
    const savedIndex = localStorage.getItem("selectedDomainIndex");
    return savedIndex !== null ? Number(savedIndex) : 0;
  });

  const config = getConfig(selectedDomainIndex);

  const providerConfig = {
    domain: config.domain,
    clientId: config.clientId,
    onRedirectCallback,
    cacheLocation: "localstorage",
    authorizationParams: {
      redirect_uri: window.location.origin,
      ...(config.audience ? { audience: config.audience } : null),
      ...(config.organization ? { organization: config.organization } : {}),
      ...(config.connection ? { connection: config.connection } : {}),
      ...(config.invitation ? { invitation: config.invitation } : {}),
      ...(config.scope ? { scope: config.scope } : {}),
    },
  };

  useEffect(() => {
    localStorage.removeItem("@@auth0spajs@@::" + config.clientId + "::" + config.domain);
  }, [selectedDomainIndex, config.clientId, config.domain]);

  return (
    <Auth0Provider key={selectedDomainIndex} {...providerConfig}>
      <AppContent
        selectedDomainIndex={selectedDomainIndex}
        setSelectedDomainIndex={setSelectedDomainIndex}
        config={config}
      />
    </Auth0Provider>
  );
};

export default App;